<template>
  <v-select
    :items="items"
    @change="selectedAgent"
    v-model="selected"
    item-text="name"
    item-value="id"
    :loading="loading"
  >
    <template v-slot:selection="{ item }">
      <div class="image">
        <img :src="getImage(item)" alt="" />
      </div>
      {{ item.first_name }} {{ item.last_name }}
    </template>
    <template v-slot:item="{ item }">
      <div class="image">
        <img :src="getImage(item)" alt="" />
      </div>
      {{ item.first_name }} {{ item.last_name }}
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    agents: Array,
    slackMap: Object,
    usedAgents: Array,
  },
  data() {
    return {
      timeout: undefined,
      selected: undefined,
      loading: false,
    };
  },
  methods: {
    getImage(agent) {
      if (!this.slackMap[agent.slack_id]) {
        return "/icon-round.png";
      }
      return this.slackMap[agent.slack_id].image;
    },
    selectedAgent(id) {
      console.log(this.selected);
      let agent = this.agents.find((agent) => {
        return agent.id === id;
      });
      this.loading = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit("selectedAgent", agent);
        this.loading = false;
      }, 500);
    },
  },
  computed: {
    items() {
      // filter out agents that are already in use
      let agents = this.agents.filter((agent) => {
        return !this.usedAgents.some((usedAgent) => {
          return agent.id === usedAgent.id;
        });
      });
      return agents;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-agent {
  height: 60px;
  .select {
    margin-top: 20px;
  }
}
.image {
  align-items: center;
  vertical-align: middle;
  height: 100%;
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>
